import { render, staticRenderFns } from "./insure-item.vue?vue&type=template&id=2fa4a381&scoped=true"
import script from "./insure-item.vue?vue&type=script&lang=js"
export * from "./insure-item.vue?vue&type=script&lang=js"
import style0 from "./insure-item.vue?vue&type=style&index=0&id=2fa4a381&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa4a381",
  null
  
)

export default component.exports